---
title: Emails I've received
subtitle: i reply to people
date: 2024-05-03 23:11
---

On the [contact page of my site,](https://cjquines.com/contact) I say that I read and reply to all emails I get. I think this is close to true, at least for my [cj@cjquines.com](mailto:cj@cjquines.com) email. Here's all the emails I got in the last year, by category:

- **Automated:** got 49, replied to 0.
- **Appreciation:** got 9, replied to 9. These are great. I print all of them, then eat the printouts.
- **Corrections:** got 3, replied to 3.
- **Questions:**
    - *about college:* got 2, replied to 2.
    - *about competitive math or programming:* got 7, replied to 6. The one email I didn't reply to had no subject, and a body that had a single screenshot of a geometry problem. What did they want?
    - *about math:* got 1, replied to 1.
    - *about programming:* got 4, replied to 4.
    - *about writing:* got 5, replied to 5.
    - *asking me to speak at an event:* got 1, replied to 1. I said no as I had a conflict.
    - *asking for an interview:* got 2, replied to 2. I said yes to both.
    - *asking for permission to use something I wrote:* got 1, replied to 1. The answer's always yes, with attribution.
- **Recruitment:** got 6, replied to 3. The ones I replied were the ones that felt personal.
- **Saying hi:** got 6, replied to 6. These are also great.
- **Spam:** got 419, replied to 0.

Anyway, if you've thought about sending an email but were feeling shy or something, please send an email! I read and reply, and I've got a track record to prove it.
